document.addEventListener("DOMContentLoaded", (event) => {
  const infoShort = document.querySelector('.coll-short-desc');
  const readBtn = document.querySelector('.coll-desc-read');
  if (infoShort && readBtn){
    const originalStyle = infoShort.style.cssText;
    infoShort.style.webkitLineClamp = 'unset';
    infoShort.style.display = 'block';
    const fullHeight = infoShort.scrollHeight;
    infoShort.style.cssText = originalStyle;
    const clampedHeight = infoShort.clientHeight;
    if (fullHeight <= clampedHeight) {
      readBtn.style.display = 'none';
    }
    readBtn.addEventListener('click', function(e) {
      e.preventDefault();
      infoShort.classList.toggle('active-full-desc');
      if (infoShort.classList.contains('active-full-desc')) {
        infoShort.style.webkitLineClamp = 'unset';
      } else {
        infoShort.style.webkitLineClamp = '2';
      }
    });
  }
  if(document.querySelector('.coll-desc-read')) document.querySelector('.coll-desc-read').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.coll-desc').classList.toggle('active-full-desc');
    if(document.querySelector('.coll-desc.active-full-desc')){
      document.querySelector('.coll-desc.active-full-desc').style.maxHeight = '';
    }
  });
  function collNavSlider(){
    let coll_nav_swiper = new Swiper(".coll-nav-slider", {
      loop: false,
      a11y: false,
      slidesPerView: "auto",
      resizeObserver: false,
    });
    const activeSlide = document.querySelector(".coll-nav-slider .swiper-slide.active");
    if (activeSlide) {
      const swiperWrapper = activeSlide.closest(".swiper-wrapper");
      const wrapperRect = swiperWrapper.getBoundingClientRect();
      const slideRect = activeSlide.getBoundingClientRect();
      const isInView =
        slideRect.left >= wrapperRect.left &&
        slideRect.right <= wrapperRect.right;
      if (!isInView) {
        const activeIndex = [...activeSlide.parentNode.children].indexOf(activeSlide);
        coll_nav_swiper.slideTo(activeIndex, 500);
      }
    }
  }
  collNavSlider();
  if(localStorage.getItem("collection_grid") == null){
    localStorage.setItem("collection_grid", document.querySelector(".coll-view a.active").getAttribute('data-view'));
  }else{
    if(document.querySelector(".collection-grid")) document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
    if(document.querySelector(".coll-view a.active").getAttribute('data-view') != localStorage.getItem("collection_grid")){
      document.querySelector(".coll-view a.active").classList.remove('active');
      let deskGrids = document.querySelectorAll(".coll-view a");
      deskGrids.forEach((deskGrid) => {
        let desk_val = deskGrid.getAttribute('data-view')
        if(parseInt(desk_val) == parseInt(localStorage.getItem("collection_grid"))){
          deskGrid.classList.add('active');
        }
      });
    }
  }




  if (document.querySelectorAll('.coll-view a')){
    document.querySelectorAll('.coll-view a').forEach((grid) => {
      grid.addEventListener('click', function(e){
        e.preventDefault();
        const visibleProducts = [];
        document.querySelectorAll('.collection-grid .product-item').forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          if (rect.top >= 0 && rect.bottom <= window.innerHeight){
            visibleProducts.push(index);
          }
        });
        localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
        const collectionGrid = document.querySelector(".collection-grid");
        if (collectionGrid) {
          collectionGrid.setAttribute('data-desk', localStorage.getItem("collection_grid"));
        }
        document.querySelectorAll(".coll-view a.active").forEach(desk_grid => {
          desk_grid.classList.remove("active");
        });
        grid.classList.add("active");
        // if (typeof callBack === "function") {
        //   callBack();
        //   quickAddButton();
        // }
        setTimeout(() => {
          document.querySelectorAll('.snippet-product-grid').forEach((product_grid) => {
            const meta = product_grid.querySelector('.grid-meta');
            if (meta) {
              meta.style.height = '';
            }
          });
          if (visibleProducts.length > 0) {
            const scrollToIndex = Math.floor(visibleProducts.length / 2);
            const target = document.querySelectorAll('.collection-grid .product-item')[visibleProducts[scrollToIndex]];
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }, 300);
      });
    });
  }

  // if(document.querySelectorAll('.coll-view a')) document.querySelectorAll('.coll-view a').forEach((grid) => {
  //   grid.addEventListener('click',function(e){
  //     e.preventDefault();
  //     localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
  //     if(document.querySelector(".collection-grid")) document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
  //     let desk_grids = document.querySelectorAll(".coll-view a.active");
  //     desk_grids.forEach((desk_grid) => {
  //       desk_grid.classList.remove("active");
  //     });
  //     grid.classList.add("active");
  //     callBack();
  //     setTimeout(() => {
  //       document.querySelectorAll('.snippet-product-grid').forEach((product_grid) => {
  //         if(product_grid.querySelector('.grid-meta')){
  //           product_grid.querySelector('.grid-meta').style.height = '';
  //         }
  //       });
  //     }, 200);
  //   });
  // });
  
  let pro_grid_filter = document.querySelector('.pro-grid-filter-btn');
  if(pro_grid_filter) pro_grid_filter.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.toggle('open-model');
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  });
  var pro_grid_filter_wrap = document.querySelector('.pro-grid-filter a');
  if(pro_grid_filter_wrap) pro_grid_filter_wrap.addEventListener('click',function(e){
    e.preventDefault();
    let main_id = pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').getAttribute('data-id');
    let current_id = pro_grid_filter_wrap.getAttribute('data-id');
    sessionStorage.setItem("col-view", current_id);
    pro_grid_filter_wrap.setAttribute('data-id',main_id);
    pro_grid_filter_wrap.textContent = main_id;
    pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').setAttribute('data-id',current_id);
    pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn span').textContent = current_id;
    document.querySelector('body').classList.remove('open-model');
    setTimeout(() => {
      callBack();
      quickAddButton();
    }, 100);
  });
  let session_val = sessionStorage.getItem("col-view");
  if(session_val != null){
    if(session_val == 'Product'){
      var pro_grid_filter_wrap = document.querySelector('.pro-grid-filter a');
      pro_grid_filter_wrap.setAttribute('data-id','Model');
      pro_grid_filter_wrap.textContent = 'Model';
      pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').setAttribute('data-id',session_val);
      pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn span').textContent = session_val;
    }
  }
});
function load_more(){
  let loadMoreBtn = document.querySelector('.load-more');
  let currentRowsLoaded = 2;
  let isLoading = false;
  let desktopProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-desk'));
  let mobileProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-mb'));
  let desktopPromoImages = document.querySelectorAll('.snippet-promo-image');
  let isMobile = window.innerWidth < 992;
  let getProductsPerRow = () => (isMobile ? mobileProductsPerRow : desktopProductsPerRow);
  let mb = parseInt(document.querySelector('#product-grid').getAttribute('data-limit') / document.querySelector('#product-grid').getAttribute('data-mb'));
  let desk = parseInt(document.querySelector('#product-grid').getAttribute('data-limit') / document.querySelector('#product-grid').getAttribute('data-desk'));
  let rowsPerLoad = isMobile ? mb : desk;

  let productGrid = document.querySelector('#product-grid');
  let loadNextPage = () => {
    if (!loadMoreBtn || isLoading) return;
    let nextPageUrl = loadMoreBtn.getAttribute('href');
    if (!nextPageUrl) return;
    isLoading = true;
    if (document.querySelector('.coll-more-scroll')) {
      let parentElement = document.querySelector('.collection-grid');
      document.querySelectorAll('.blank-span').forEach(blankDiv => blankDiv.remove());
      let spanWrapper = document.createElement("span");
      spanWrapper.classList.add("blank-span");
      for(let i = 0; i < 6; i++){
        let child = document.createElement("span");
        spanWrapper.appendChild(child);
      }
      parentElement.appendChild(spanWrapper);
      document.querySelector('.coll-more-scroll').classList.add('loading');
    }
    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        // document.querySelectorAll('.blank-span').forEach(blankDiv => {
        //   blankDiv.remove();
        // });
        
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        let newProducts = doc.querySelectorAll('.collection-grid .product-item');
        let nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');

        // newProducts.forEach(product => {
        //   let productId = product.getAttribute('data-id');
        //   if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
        //     product.classList.add("loading"); // start with skeleton
        //     let img = product.querySelector("img");
        //     if (img) {
        //       img.addEventListener("load", () => {
        //         product.classList.remove("loading");
        //         product.classList.add("loaded");
        //       });
        //       // In case image is cached
        //       if (img.complete) {
        //         product.classList.remove("loading");
        //         product.classList.add("loaded");
        //       }
        //     }
        //     productGrid.appendChild(product);
        //   }
        // });
        
        // newProducts.forEach(product => {
        //   let productId = product.getAttribute('data-id');
        //   if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
        //     setTimeout(() => {
        //       productGrid.appendChild(product);
        //       product.classList.add('init-loading-item');
        //       setTimeout(() => {
        //         product.classList.remove('init-loading-item');
        //         if(!product.classList.contains('init-loading-item')){
        //           document.querySelector('.coll-more-scroll').classList.remove('loading');
        //         }
        //       }, 1000);
        //     }, 1000);
        //   }
        // });
        newProducts.forEach(product => {
          let productId = product.getAttribute('data-id');
          if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
            product.classList.add('init-loading-item');
            productGrid.appendChild(product);
            setTimeout(() => {
              product.classList.remove('init-loading-item');
            }, 100);
          }
        });
        if (newProducts.length > 0) {
          setTimeout(() => {
            document.querySelector('.coll-more-scroll')?.classList.remove('loading');
            if (typeof quickAddButton === 'function') {
              console.log('called');
              quickAddButton();
            }
          }, 600);
        }


        // for(let i = 0; i < parseInt(document.querySelector('.collection-grid').getAttribute('data-limit')); i++){
        //   let span = document.createElement("span");
        //   span.classList.add("blank-span");
        //   parentElement.appendChild(span);
        // }
        currentRowsLoaded += rowsPerLoad;
        let displayPromoImages = (promoImages, rowAttribute) => {
          promoImages.forEach(promo => {
            let promoRow = parseInt(promo.getAttribute(rowAttribute), 10);
            let productsPerRow = getProductsPerRow();
            let productsLoaded = currentRowsLoaded * productsPerRow;
  
            if (promoRow <= currentRowsLoaded + rowsPerLoad && promo.style.display === 'none') {
              setTimeout(()=>{
                promo.style.display = 'block';
                productGrid.appendChild(promo);
              },500);
            }
          });
        };
        let isMobileNow = window.innerWidth < 992;
        if (isMobileNow) {
          displayPromoImages(desktopPromoImages, 'data-mobile-row');
        }else{
          displayPromoImages(desktopPromoImages, 'data-desk-row');
        }
        
        if (nextPaginationLink) {
          loadMoreBtn.setAttribute('href', nextPaginationLink.getAttribute('href'));
        } else {
          document.querySelector('.coll-more-scroll').remove();
        }
        
        $th_refreshWishlistItems();
        setTimeout(() => {
          callBack(true);
        }, 100);
      })
      .catch(err => console.error('Error loading products:', err))
      .finally(() => {
        isLoading = false;
      });
  };
  let observeLoadMoreBtn = () => {
    if (!loadMoreBtn) return;
    let observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px 500px 0px',
    };
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          loadNextPage();
        }
      });
    }, observerOptions);
    observer.observe(loadMoreBtn);
  };
  observeLoadMoreBtn();
}
load_more();
document.addEventListener("DOMContentLoaded", () => {
  const target = document.querySelector('.shopify-section-group-footer-group');
  if (!target) return;
  function toggleBodyClass() {
    const rect = target.getBoundingClientRect();
    const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
    document.body.classList.toggle('hide-sticky-filter', inViewport);
  }
  toggleBodyClass();
  window.addEventListener('scroll', toggleBodyClass);
  window.addEventListener('resize', toggleBodyClass);
});